import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Table,
  Space,
} from "antd";
import {
  CloseOutlined,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../utils/axiosInterceptor";
import StaticTable from "../../components/tables/StaticTable";
import SmsPrivacy from "../../components/smsPrivacyPages/SmsPrivacy";
import SmsTermsAndConditions from "../../components/smsPrivacyPages/SmsTermsAndConditions";
// import { useSelector } from "react-redux";

export default function ProfilePopup({
  popupWithScrollViewVisible,
  hide,
  data,
  userDetailsState,
  isAdmin
}) {
  const [form] = Form.useForm();
  const [userAccounts, setUserAccounts] = useState([]);
  const userDetails = useSelector((state) => state.userAuth.decodedToken.user);
  const [loading, setLoading] = useState(false)
  const [fileshowing, setFileShowing] = useState(false)
  const [pageSize, setPageSize] = useState(10);
  const [smsPrivacyModal, setSmsPrivacyModal] = useState(false);
  const [smsPrivacyTermsModal, setSmsPrivacyTermsModal] = useState(false);



  useEffect(() => {
    if (popupWithScrollViewVisible && userDetails?.email) {
      fetchAccounts();
      if (userDetails) {
        form.setFieldsValue(userDetails);
      }
    }
  }, [popupWithScrollViewVisible, form]);

  const fetchAccounts = async () => {
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(
        `/users/accounts?email=${userDetails?.email}&skip=1&take=10`,
        // {
        //   headers: { Authorization: `Bearer ${token}` },
        // }
      );
      setUserAccounts(response?.data?.data?.data || []);
      setLoading(false)
    } catch (err) {
      console.error("Error fetching accounts:", err);
      setLoading(false)
    }
  };

  const statusOptions = [
    { value: 0, label: "Not Registered" },
    { value: 1, label: "Registered/Active" },
    { value: 3, label: "Disabled" },
  ];

  const userRoleOptions = [
    { value: 1, label: "User" },
    { value: 2, label: "Admin" },
    { value: 3, label: "Manager" },
    {
      value: 4,
      label: userDetailsState?.user_roles_id
    },
    {
      value: 5,
      label: 'Super Admin'
    },
  ];

  const accountColumns = [
    { title: "Number", dataIndex: "acct_id", key: "acct_id" },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "City", dataIndex: "city", key: "city" },
    { title: "State", dataIndex: "state", key: "state" },
  ];
  const columns = [
    { title: "McKesson", dataIndex: "label", key: "label" },
    { title: "Admin Fee Percent", dataIndex: "fee", key: "fee" },
  ];
  const columns2 = [
    { title: "IPC", dataIndex: "label", key: "label" },
    { title: "Admin Fee Percent", dataIndex: "fee", key: "fee" },
  ];

  return (
    <Modal
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>User Profile</span>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={hide}
            style={{
              marginRight: -12,
            }}
          />
        </div>
      }
      open={popupWithScrollViewVisible}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="profile-modal"
      closeIcon={null}
      footer={null}
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <Form form={form} layout="vertical">
        <div
          // style={{
          //   display: "grid",
          //   gridTemplateColumns: "repeat(3, 1fr)",
          //   gap: "16px",
          // }}
          className="form-grid gap-x-7"
        >
          <Form.Item name="email" label="Email">
            <Input
              prefix={<MailOutlined />}
              readOnly
              placeholder="Email address"
              style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px" }}
            />
          </Form.Item>

          <Form.Item name="status" label="Status">
            <Select
              disabled
              options={statusOptions}
              style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px", "border-radius": "6px" }}
            />
          </Form.Item>

          <Form.Item name="user_roles_id" label="User Role">
            <Select
              disabled
              options={userRoleOptions}
              style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px", "border-radius": "6px" }}
            />
          </Form.Item>

          <Form.Item name="first_name" label="First Name">
            <Input style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px" }}
              prefix={<UserOutlined />} readOnly />
          </Form.Item>

          <Form.Item name="middle_name" label="Middle Name">
            <Input style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px" }}
              prefix={<UserOutlined />} readOnly />
          </Form.Item>

          <Form.Item name="last_name" label="Last Name">
            <Input style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px" }}
              prefix={<UserOutlined />} readOnly />
          </Form.Item>

          <Form.Item name="phone" label="Mobile Phone">
            <Input style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)", height: "40px" }}
              prefix={<PhoneOutlined />} readOnly />
          </Form.Item>

          <Form.Item name="send_email" valuePropName="checked"
            style={{ marginTop: "35px" }}
          >
            <Checkbox disabled>Send Email</Checkbox>
          </Form.Item>

          <Form.Item name="send_sms" valuePropName="checked"
            style={{ marginTop: "35px" }}
          >
            <Checkbox disabled>Send SMS</Checkbox>
          </Form.Item>
        </div>

        <div style={{ marginTop: "24px" }}>
          <Space
            style={{
              marginBottom: "16px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h5 style={{ margin: 0, fontSize: "16px", color: "#262626" }}>
              Account List
            </h5>
          </Space>

          <Table
            loading={loading}
            columns={accountColumns}
            dataSource={userAccounts}
            size="small"
            scroll={{ y: 400, x: 400 }}
            rowKey="acct_id"
            pagination={{
              pageSize: pageSize,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} accounts`,
              onShowSizeChange: (current, size) => {
                setPageSize(size);
              },
            }}
          />
        </div>
      </Form>
      <div onClick={() => {
        setSmsPrivacyModal(true);
      }
      } className="flex ">
        <span className="text-[#1890ff] cursor-pointer hover:underline text-[16px]">
          SMS Privacy Policy
        </span>
      </div>
      <div className="flex " onClick={() => {
        setSmsPrivacyTermsModal(true);
      }
      }>
        <span className="text-[#1890ff] cursor-pointer hover:underline text-[16px]">
          SMS Terms And Conditions
        </span>
      </div>
      {/* <div onClick={() => {
          setFileShowing(true);
        }
        } className="flex ">
          <span className="text-[#1890ff] cursor-pointer hover:underline text-[16px]">
            Legal Disclosure Statement
          </span>
        </div> */}
      <StaticTable
        hide={() => setFileShowing(false)}
        visible={fileshowing}
      />
      <SmsPrivacy
        hide={() => setSmsPrivacyModal(false)}
        visible={smsPrivacyModal}
      />
      <SmsTermsAndConditions
        hide={() => setSmsPrivacyTermsModal(false)}
        visible={smsPrivacyTermsModal}
      />

    </Modal>
  );
}
